"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrusteeSchema = exports.TrusteePrimaryContactSchema = exports.PRIMARY_CONTACT_REQUIRED = exports.COMPANY_ADDRESS_REQUIRED = exports.ASIC_IDENTIFIER_REQUIRED = exports.COMPANY_NAME_REQUIRED = exports.EMAIL_INVALID = exports.EMAIL_REQUIRED = exports.RESIDENTIAL_ADDRESS_REQUIRED = exports.LAST_NAME_REQUIRED = exports.FIRST_NAME_REQUIRED = exports.TRUSTEE_TYPE_REQUIRED = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const AsicAddress_1 = require("./AsicAddress");
exports.TRUSTEE_TYPE_REQUIRED = "Please select the trustee type";
exports.FIRST_NAME_REQUIRED = "Please enter the first name";
exports.LAST_NAME_REQUIRED = "Please enter the last name";
exports.RESIDENTIAL_ADDRESS_REQUIRED = "Please enter the residential address";
exports.EMAIL_REQUIRED = "Please enter the email";
exports.EMAIL_INVALID = "Email must be a valid email";
exports.COMPANY_NAME_REQUIRED = "Please enter the company name";
exports.ASIC_IDENTIFIER_REQUIRED = "Please enter the ACN or ABN";
exports.COMPANY_ADDRESS_REQUIRED = "Please enter the registered address";
exports.PRIMARY_CONTACT_REQUIRED = "Please enter the primary contact";
const isIndividual = (trusteeType) => trusteeType === mystake_common_sdk_1.TrusteeType.INDIVIDUAL;
const isCompany = (trusteeType) => trusteeType === mystake_common_sdk_1.TrusteeType.COMPANY;
const addressSchema = () => yup
    .object()
    .shape({ ...AsicAddress_1.AsicAddressSchema })
    .default(undefined);
const phoneSchema = () => yup
    .object()
    .shape({
    iso2: yup.string().trim(),
    dialCode: yup.string().trim(),
    phoneNumber: yup
        .string()
        .trim()
        .max(14, "Phone Numbers must be at most 14 digits")
        .matches(/^[0-9]*$/, { excludeEmptyString: true, message: "Phone Numbers can only contain digits" }),
})
    .default(undefined);
const emailSchema = () => yup.string().trim().email(exports.EMAIL_INVALID).max(255);
/** The person acting for a company trustee; the trustee company itself never holds a login. */
exports.TrusteePrimaryContactSchema = yup
    .object()
    .shape({
    firstName: yup.string().trim().required(exports.FIRST_NAME_REQUIRED).max(120),
    middleName: yup.string().trim().max(120),
    lastName: yup.string().trim().required(exports.LAST_NAME_REQUIRED).max(120),
    contactTypes: yup
        .array()
        .of(yup.string().oneOf(Object.values(mystake_common_sdk_1.ContactType)))
        .optional(),
    email: emailSchema().required(exports.EMAIL_REQUIRED),
    phone: phoneSchema(),
})
    .default(undefined);
/**
 * A trustee of a Trust/SMSF investor holding. Carries no tax residency, tax identifier or FATCA/CRS
 * field for either variant.
 */
exports.TrusteeSchema = yup.object().shape({
    _id: yup.string(),
    companyId: yup.string(),
    shareholderId: yup.string(),
    trusteeType: yup.string().oneOf(Object.values(mystake_common_sdk_1.TrusteeType), exports.TRUSTEE_TYPE_REQUIRED).required(exports.TRUSTEE_TYPE_REQUIRED),
    firstName: yup.lazy(() => yup
        .string()
        .trim()
        .max(120)
        .when("trusteeType", ([trusteeType], schema) => isIndividual(trusteeType) ? schema.required(exports.FIRST_NAME_REQUIRED) : schema)),
    middleName: yup.string().trim().max(120),
    lastName: yup.lazy(() => yup
        .string()
        .trim()
        .max(120)
        .when("trusteeType", ([trusteeType], schema) => isIndividual(trusteeType) ? schema.required(exports.LAST_NAME_REQUIRED) : schema)),
    dateOfBirth: yup.date().nullable().optional(),
    citizenshipCountries: yup.array().of(yup.string().trim().required()).optional(),
    // The form row carries both variants so switching type keeps what was typed, so the half that is
    // not selected must not be validated — its blank fields would otherwise refuse a complete trustee.
    residentialAddress: yup
        .mixed()
        .when("trusteeType", ([trusteeType]) => isIndividual(trusteeType) ? addressSchema().required(exports.RESIDENTIAL_ADDRESS_REQUIRED) : yup.mixed().notRequired()),
    email: yup.lazy(() => emailSchema().when("trusteeType", ([trusteeType], schema) => isIndividual(trusteeType) ? schema.required(exports.EMAIL_REQUIRED) : schema)),
    // Optional for both variants: a trustee can be reached by email, and the design marks it optional.
    phone: phoneSchema(),
    companyName: yup.lazy(() => yup
        .string()
        .trim()
        .max(200)
        .when("trusteeType", ([trusteeType], schema) => isCompany(trusteeType) ? schema.required(exports.COMPANY_NAME_REQUIRED) : schema)),
    // A foreign company trustee has no ACN/ABN to give.
    asicCompanyIdentifier: yup.lazy(() => yup
        .string()
        .trim()
        .when(["trusteeType", "isForeignEntity"], ([trusteeType, isForeignEntity], schema) => isCompany(trusteeType) && !isForeignEntity ? schema.required(exports.ASIC_IDENTIFIER_REQUIRED) : schema)),
    isForeignEntity: yup.boolean(),
    tfn: yup.string().trim(),
    address: yup
        .mixed()
        .when("trusteeType", ([trusteeType]) => isCompany(trusteeType) ? addressSchema().required(exports.COMPANY_ADDRESS_REQUIRED) : yup.mixed().notRequired()),
    primaryContact: yup
        .mixed()
        .when("trusteeType", ([trusteeType]) => isCompany(trusteeType)
        ? exports.TrusteePrimaryContactSchema.required(exports.PRIMARY_CONTACT_REQUIRED)
        : yup.mixed().notRequired()),
});
// Login state (userId, invitationSentDate, lastLogin) is deliberately absent at both levels: it is
// written by the invitation route alone. Accepting it here would let a caller bind an arbitrary
// account to a trustee, and holding authorization matches on exactly those fields.
//# sourceMappingURL=Trustee.js.map